import { createStore } from 'vuex';

export default createStore({

  state: {
    isLoggedIn: false,
    userName: null,
    userRole: null,
    flashMessage: '',
    flashType: '',
    isFlashVisible: false
  },
  mutations: {
    setLoggedIn(state, value) {
      state.isLoggedIn = value;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    setUserRole(state, role) {
      state.userRole = role;
    },
    setFlashMessage(state, { message, type }) {
      state.flashMessage = message;
      state.flashType = type; // 'success', 'danger', 'warning' など
      state.isFlashVisible = true;
      setTimeout(() => {
        state.isFlashVisible = false;
      }, 1200); // 3秒後にメッセージを非表示にする
    }
  },
  actions: {
    setLoggedIn({ commit }, status) {
      commit('setLoggedIn', status);
    },
    setUserName({ commit }, status) {
      commit('setUserName', status);
    },
    setUserRole({ commit }, status) {
      commit('setUserRole', status);
    }
  }
});
